import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { uuid } from '@helsenorge/designsystem-react';
import { fetchTjenesteTekster } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { getPath } from '@helsenorge/framework-utils/hn-page';
import { fetchResources, getResourcesFromState } from '@helsenorge/framework-utils/resources';
import HjelpebobleComponent from './hjelpeboble-component';
import HjelpetriggerContainer from './hjelpetrigger-container';
import { getResources, Projects } from '../../resources';
import { addHjelpetrigger, removeHjelpetrigger, populateSkuff, getTriggerData, getActiveBubble, setActiveBubble, toggleShowHelpItem, } from '../hjelpeskuff/hjelpeskuff-state';
export const GetResourcesEvent = 'HN-Get-Resources';
class Hjelpetrigger extends React.Component {
    constructor(props) {
        super(props);
        this.validateProps(props);
        this.handleBubbleClick = this.handleBubbleClick.bind(this);
        this.handleTriggerClick = this.handleTriggerClick.bind(this);
        this.getResourcesEvent = this.getResourcesEvent.bind(this);
        this.state = {
            triggerComponentId: this.createUniqueId(),
        };
    }
    componentDidMount() {
        if (this.props.mount) {
            this.props.mount();
        }
        const { dispatch } = this.props;
        if (!this.props.isDefault && dispatch && this.state.triggerComponentId) {
            dispatch(addHjelpetrigger(this.state.triggerComponentId));
        }
        if (this.props.populateSkuff && dispatch && this.props.hjelpetekstId && this.props.tjenesteNavn) {
            dispatch(populateSkuff(this.props.hjelpetekstId, this.props.tjenesteNavn));
        }
        window.addEventListener(GetResourcesEvent, this.getResourcesEvent);
    }
    componentWillUnmount() {
        const { dispatch } = this.props;
        if (!this.props.isDefault && dispatch && this.state.triggerComponentId) {
            dispatch(removeHjelpetrigger(this.state.triggerComponentId));
        }
        window.removeEventListener(GetResourcesEvent, this.getResourcesEvent);
    }
    getResourcesEvent(event) {
        if (event.detail && event.detail.tjenesteNavn && this.props.dispatch) {
            this.props.dispatch(fetchResources({ project: Projects.FRAMEWORK, language: event.detail.language, getResources }));
            this.props.dispatch(fetchTjenesteTekster({ name: event.detail.tjenesteNavn, language: event.detail.language }));
        }
    }
    createUniqueId() {
        return uuid();
    }
    validateProps(props) {
        if (props.isDefault) {
            this.validateDefaultProps(props);
        }
        else if (!props.hjelpetekstId) {
            throw new Error('HjelpetekstId må angis for helpTrigger');
        }
    }
    validateDefaultProps(props) {
        if (!props.isDefault) {
            return;
        }
        if (props.hjelpetekstId) {
            throw new Error('Default helptrigger kan ikke ha en hjelpetekstId...');
        }
    }
    handleBubbleClick() {
        const { dispatch } = this.props;
        const { triggerComponentId } = this.state;
        if (dispatch) {
            if (this.isBubbleVisible()) {
                dispatch(setActiveBubble(''));
            }
            else if (triggerComponentId) {
                dispatch(setActiveBubble(triggerComponentId));
            }
        }
    }
    handleTriggerClick(overrideHelpetekstId, overrideTjenesteNavn) {
        const { dispatch, hjelpetekstId, tjenesteNavn } = this.props;
        const { triggerComponentId } = this.state;
        const newHjelpetekstId = overrideHelpetekstId || hjelpetekstId;
        const newTjenesteNavn = overrideTjenesteNavn || tjenesteNavn;
        if (dispatch) {
            dispatch(toggleShowHelpItem(triggerComponentId ? triggerComponentId : '', newHjelpetekstId, newTjenesteNavn || ''));
        }
    }
    isBubbleVisible() {
        const { activeBubble } = this.props;
        const { triggerComponentId } = this.state;
        return activeBubble === triggerComponentId;
    }
    renderHjelpetrigger() {
        const { isDefault, triggerData, stopPropagation, ...other } = this.props;
        const extraProps = {
            triggerComponentId: this.state.triggerComponentId,
        };
        if (!isDefault && triggerData) {
            extraProps.sporsmalstekst = triggerData.sporsmalstekst;
        }
        return (_jsx(HjelpetriggerContainer, { size: this.props.size, ...other, ...extraProps, onClick: this.handleTriggerClick, stopPropagation: stopPropagation }));
    }
    render() {
        const { resources, triggerData, hjelpetekstId, tjenesteNavn, isDefault, bubbleText, moreHelpText } = this.props;
        if (!resources) {
            return null;
        }
        let helpTriggerItem;
        if (bubbleText || (triggerData && triggerData.bobletekst)) {
            helpTriggerItem = (_jsx(HjelpebobleComponent, { hjelpetekstId: hjelpetekstId, resources: resources, onChange: this.handleBubbleClick, onShowMoreClick: this.handleTriggerClick, visible: this.isBubbleVisible(), triggerData: triggerData, tjenesteNavn: tjenesteNavn, bubbleText: bubbleText, moreHelpText: moreHelpText }));
        }
        else if (isDefault || triggerData) {
            helpTriggerItem = this.renderHjelpetrigger();
        }
        return _jsx("span", { children: helpTriggerItem });
    }
}
function mapStateToProps(state, props) {
    return {
        resources: getResourcesFromState(state, Projects.FRAMEWORK),
        tjenesteNavn: props.tjenesteNavn || getPath(),
        triggerData: props.isDefault ? undefined : getTriggerData(state, props.hjelpetekstId || '', props.tjenesteNavn || getPath() || ''),
        activeBubble: getActiveBubble(state),
    };
}
function mapDispatchToProps(dispatch, props) {
    return {
        mount: () => {
            dispatch(fetchResources({ project: Projects.FRAMEWORK, language: props.language ?? LanguageLocales.NORWEGIAN, getResources }));
            const tjenesteNavn = props.tjenesteNavn ?? getPath();
            if (tjenesteNavn) {
                dispatch(fetchTjenesteTekster({ name: tjenesteNavn, language: props.language ?? LanguageLocales.NORWEGIAN }));
            }
        },
        dispatch,
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Hjelpetrigger);
